import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eb415c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-investigation-details" }
const _hoisted_2 = { class: "general-accounts" }
const _hoisted_3 = { class: "table-top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "__left" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Investigations"),
  /*#__PURE__*/_createElementVNode("h2", null, "View investigation details")
], -1))
const _hoisted_5 = { class: "__right" }
const _hoisted_6 = { class: "ls-table" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["colspan"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["colspan"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = ["colspan"]
const _hoisted_17 = { "data-label": "INV ID" }
const _hoisted_18 = { "data-label": "Investigation type" }
const _hoisted_19 = { "data-label": "Commencement date" }
const _hoisted_20 = { "data-label": "Status" }
const _hoisted_21 = { "data-label": "Reply actions" }
const _hoisted_22 = { style: {"text-align":"center"} }
const _hoisted_23 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.addInvestigations()))
          }, "Add Investigations")
        ])
      ]),
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", {
                class: _normalizeClass([ h.sortable ? 'sortable' : '']),
                onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(h.text), 1),
                  (h.sortable)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', h.sortMethod])
                      }, _hoisted_10, 2))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_7))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_12)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_14)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.investigations.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeadings.length
                    }, "No Records", 8, _hoisted_16)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.investigations.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.investigationsDisplay, (i) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_17, _toDisplayString(i.id), 1),
                        _createElementVNode("td", _hoisted_18, _toDisplayString(i.investigationTypeName), 1),
                        _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$formatDate(i.commencementDate)), 1),
                        _createElementVNode("td", _hoisted_20, _toDisplayString(i.status), 1),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(i.isReplyRequired ? 'Yes' : ''), 1),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("button", {
                            class: "btn btn-default sml",
                            onClick: $event => (_ctx.showInvestigationDetails(i))
                          }, "View", 8, _hoisted_23)
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}